import { createFileRoute } from '@tanstack/react-router';
import SendVolumeTab from '@/pages/workspaces/broadcasts/send-volume/index.page';
import { RumPageRendered } from '@/services/rum/use-page-rendered';
import { validateSendVolumeSearch } from '@/pages/workspaces/broadcasts/url-state';

function SendVolumeRoute() {
  return (
    <RumPageRendered>
      <SendVolumeTab />
    </RumPageRendered>
  );
}

export const Route = createFileRoute('/_authenticated/workspaces/$workspaceId/broadcasts/send-volume')({
  component: SendVolumeRoute,
  validateSearch: validateSendVolumeSearch,
});
